import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderNpiValidate: build.mutation<
      PostV2ProviderNpiValidateApiResponse,
      PostV2ProviderNpiValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/npi/validate`,
        method: "POST",
        body: queryArg.validateNpiRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderNpiValidateApiResponse =
  /** status 200 OK */ ValidateNpiResponse;
export type PostV2ProviderNpiValidateApiArg = {
  validateNpiRequest: ValidateNpiRequest;
};
export type NpiExpectedType = "individual" | "organization";
export type NpiValidationStatus =
  | "valid"
  | "wrong_type"
  | "not_found"
  | "malformed"
  | "unverified";
export type ValidateNpiResponse = {
  /** NPPES enumeration type: NPI-1 or NPI-2, if found. */
  enumeration_type?: string | null;
  expected_type: NpiExpectedType;
  /** Human-readable, display-ready summary. */
  message: string;
  npi: string;
  /** Primary taxonomy description from NPPES, if found. */
  primary_taxonomy?: string | null;
  /** Name on file in NPPES, for confirm-what-you-typed UX. */
  registry_name?: string | null;
  status: NpiValidationStatus;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type NpiExpectedType2 = "individual" | "organization";
export type ValidateNpiRequest = {
  /** Whether this field should hold an individual (rendering) or organization (group/billing) NPI. */
  expected_type: NpiExpectedType2;
  /** The NPI to validate. */
  npi: string;
};
